export const PRIMARY_TYPE = 'primary'
export const SECONDARY_TYPE = 'secondary'
export const TERTIARY_TYPE = 'tertiary'
export const PRIME_TYPE = 'prime'

export const BIG_SIZE = 'BIG_SIZE'
export const SMALL_SIZE = 'SMALL_SIZE'

export const VARIANTS = [PRIMARY_TYPE, SECONDARY_TYPE, TERTIARY_TYPE, PRIME_TYPE]
export const SIZES_VARIANTS = [SMALL_SIZE, BIG_SIZE]
